// pipes
import { titleCasePipe } from 'shared/pipes';

const ListTable = ({ customers }) => {

    if (!customers || customers.length === 0) {
        return (
            <div className="box has-background-light">
                <article className="message p-6">
                    <div className="message-body">
                        List not created.
                    </div>
                </article>
            </div>
        );;
    }

    return (
        <table className="table is-striped is-fullwidth">
            <thead>
                <tr>
                    <th>Index</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Stylist</th>
                    <th>Distribution</th>
                    <th>HYC Status</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {customers?.map((customer) => {
                    return (
                        <tr key={`key-${customer.index}`}>
                            <td>{customer.index}</td>
                            <td>{customer.full_name}</td>
                            <td>{customer.email}</td>
                            <td>{customer.box_stylist}</td>
                            <td>{customer.distribution_partner}</td>
                            <td>{titleCasePipe.transform(customer.hyc_status)}</td>
                            <td>{titleCasePipe.transform(customer.status)}</td>
                        </tr>
                    )
                })}

            </tbody>
        </table>
    )
}
export { ListTable };
